// extracted by mini-css-extract-plugin
export var container = "ourPartnersTabs-module--container--7b71d";
export var content = "ourPartnersTabs-module--content--78e7d";
export var logo = "ourPartnersTabs-module--logo--d1f33";